/**
 * Track a user interaction event
 * @param {Object} eventData event options
 */
export const trackEvent = eventData => {
  if (window.dataLayer) {
    window.dataLayer.push(eventData);
  }
};
